//@ts-nocheck
import React, { useEffect, useMemo, useRef, useState } from "react";
import { v4 as uuidv4 } from "uuid";
import Datepicker from "react-tailwindcss-datepicker";
import { format } from "date-fns";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useSidebar } from "../../../context/SidebarContext";
import { fetchJobPipelineDetailsData } from "../../../features/pipeline/pipelineSlice";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import {
  SortAscendingIcon,
  SortDecendingIcon,
} from "../../../components/icons/Icons";
import { useSearch } from "../../../context/SearchContext";
import Reports from "./Reports";

export default function ApplicationJobHeaderReports() {
  const [activeButton, setActiveButton] = useState("one");
  const [sectionHeight, setSectionHeight] = useState(0);
  const [isMainMenuOpen, setIsMainMenuOpen] = useState(false);
  const [boardsMenuOpen, setBoardsMenuOpen] = useState(false);
  const [createdMenuOpen, setCreatedMenuOpen] = useState(false);
  const storedFilters = localStorage.getItem("activeFiltersJobReports");
  const initialFilters = storedFilters
    ? JSON.parse(storedFilters)
    : {
        Stages: [],
        "Created at": [],
        "Updated By": [],
        Sort: [],
        search: "",
        //pagination
        pagination: {
          pageIndex: 0,
          pageSize: 25,
        },
      };
  const [activeFilters, setActiveFilters] = useState({
    ...initialFilters,
    // search: searchTerm,
  });
  const [searchQuery, setSearchQuery] = useState("");
  const [createdSearchQuery, setCreatedSearchQuery] = useState("");
  const selectedValuesRef = useRef<HTMLDivElement>(null);
  const [localItemBoards, setLocalItemBoards] = useState([]);
  const [localItemStatus, setLocalItemStatus] = useState([]);
  const [activeIndex, setActiveIndex] = useState(-1);
  const [activeIndex1, setActiveIndex1] = useState(-1);
  const [activeState, setActiveState] = useState("all");
  const [boardsSearchQuery, setBoardsSearchQuery] = useState("");
  const [sentimentSearchQuery, setSentimentSearchQuery] = useState("");
  const [selectedTags, setSelectedTags] = useState(() => {
    const storedFilters = localStorage.getItem("activeFiltersJobReports");
    const initialFilters = storedFilters
      ? JSON.parse(storedFilters)
      : {
          Stages: [],
          "Created at": [],
          "Updated By": [],
          search: "",
        };
    return initialFilters.member || [];
  });

  const [updatedMenuOpen, setUpdatedMenuOpen] = useState(false);
  const [assignedItemId, setAssignedItemId] = useState<string | null>(null);
  const { searchTerm, clearAll } = useSearch();
  const location = useLocation();
  const [assignedStatusDraftId, setAssignedStatusDraftId] = useState<
    string | null
  >(null);
  const [assignedStatusPendingId, setAssignedStatusPendingId] = useState<
    string | null
  >(null);
  const [assignedStatusCompletedId, setAssignedStatusCompletedId] = useState<
    string | null
  >(null);
  const [activeStatus, setActiveStatus] = useState("all");
  const { verticleSidebar, setVerticleSidebar } = useSidebar();
  const [showKanbanRoute, setShowKanbanRoute] = useState(false);
  const [showReports, setShowReports] = useState(false);
  const { jobId } = useParams<{ jobId: string }>();
  const { baseId } = useParams<{ baseId: string }>();
  const navigate = useNavigate();
  const [sortMenuOpen, setSortMenuOpen] = useState(false);
  const sortMenuRef = useRef(null);
  const [sortSearchQuery, setSortSearchQuery] = useState("");
    const isChatOpen = useAppSelector((state: any) => state.ui?.isChatbotOpen);

  const dispatch = useAppDispatch();
  useEffect(() => {
    if (searchTerm !== undefined) {
      setActiveFilters((prevFilters) => ({
        ...prevFilters,
        search: searchTerm,
      }));
    }
  }, [searchTerm]);

  useEffect(() => {
    setActiveFilters({
      ...initialFilters,
      search: "",
    });
  }, [location.pathname]);

  useEffect(() => {
    // Synchronize activeStatus with the current URL
    const path = location.pathname;
    if (path.includes("application")) {
      setActiveStatus("Application");
      setShowKanbanRoute(false);
    } else if (path.includes("pipeline")) {
      setActiveStatus("Pipeline");
      setShowKanbanRoute(true);
    } else if (path.includes("reports")) {
      setActiveStatus("Reports");
      setShowKanbanRoute(false);
    }
  }, [location.pathname]);

  const handleStatusDraft = () => {
    setActiveStatus("Application");
    setShowKanbanRoute(false);
    setShowReports(false);
    navigate(`/${baseId}/job/${jobId}/application`);
  };

  const handleStatusPending = async () => {
    setActiveStatus("Pipeline");
    setShowKanbanRoute(true);
    setShowReports(false);
    navigate(`/${baseId}/job/${jobId}/pipeline`);
    if (jobId && baseId) {
      try {
        const res = await dispatch(
          fetchJobPipelineDetailsData({ baseId: Number(baseId), JobId: jobId }),
        ).unwrap();
        localStorage.setItem("jobPipelineStageData", JSON.stringify(res?.data));
      } catch (error) {
        console.error("Error fetching document:", error);
      }
    }
  };

  const handleStatusCompleted = () => {
    setActiveStatus("Reports");
    setShowKanbanRoute(false);
    setShowReports(true);
    navigate(`/${baseId}/job/${jobId}/reports`);
  };

  // stage
  useEffect(() => {
    if (baseId) {
      const fetchJob = async () => {
        const storedBoardsItems = localStorage.getItem("jobPipelineStageData");
        if (storedBoardsItems) {
          const parsedItems = JSON.parse(storedBoardsItems);
          if (parsedItems && parsedItems) {
            setLocalItemBoards(parsedItems?.stages);
          }
        } else {
          try {
            const res = await dispatch(
              fetchJobPipelineDetailsData({
                baseId: Number(baseId),
                JobId: jobId,
              }),
            ).unwrap();
            if (res && res.data) {
              setLocalItemBoards(res?.data?.stages);
              // }
            }
          } catch (error) {
            console.error("Error fetching base member details:", error);
          }
        }
      };
      fetchJob();
    }
  }, [baseId, dispatch]);

  const [editingFilter, setEditingFilter] = useState(null);

  const toggleFilter = (category, newFilter) => {
    setActiveFilters((prevFilters) => ({
      ...prevFilters,
      [category]: [newFilter], // Only keep the new filter
    }));
  };

  // const toggleFilter = (category, newFilter) => {
  //   setActiveFilters((prevFilters) => {
  //     const categoryFilters = prevFilters[category] || [];
  //     const existingFilterIndex = categoryFilters.findIndex(
  //       (filter) => filter.id === newFilter.id
  //     );

  //     let updatedCategoryFilters;
  //     if (existingFilterIndex !== -1) {
  //       updatedCategoryFilters = categoryFilters.map((filter, index) =>
  //         index === existingFilterIndex ? newFilter : filter
  //       );
  //     } else {
  //       updatedCategoryFilters = [...categoryFilters, newFilter];
  //     }
  //     return {
  //       ...prevFilters,
  //       [category]: updatedCategoryFilters
  //     };
  //   });
  // };

  const itemsRef1 = useRef([]);
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "ArrowUp") {
        setActiveIndex1((prevIndex) => {
          const newIndex = Math.max(prevIndex - 1, 0);
          scrollItemIntoView(newIndex);
          return newIndex;
        });
      } else if (event.key === "ArrowDown") {
        setActiveIndex1((prevIndex) => {
          const newIndex = Math.min(prevIndex + 1, localItemStatus.length - 1);
          const newIndex1 = Math.min(prevIndex + 1, localItemBoards.length - 1);
          scrollItemIntoView(newIndex);
          scrollItemIntoView(newIndex1);
          return Math.max(newIndex, newIndex1);
        });
      } else if (event.key === "Enter") {
        if (activeIndex1 >= 0) {
          let newFilter = null;
          if (boardsMenuOpen && activeIndex1 < localItemBoards.length) {
            const selectedItem = localItemBoards[activeIndex1];
            newFilter = {
              id: selectedItem.id,
              label: "Stages",
              value: selectedItem.name,
              icon: <BadgeBoards borderColor={selectedItem.color} />,
            };
            setBoardsMenuOpen(false);
            setBoardsSearchQuery("");
          }
          // sorting

          if (sortMenuOpen && activeIndex1 < localItemStatus.length) {
            const selectedItem = localItemStatus[activeIndex1];
            newFilter = {
              id: selectedItem.id,
              label: "Sort",
              value: selectedItem.name,
              icon: <BadgeStatus borderColor={selectedItem.color} />,
            };
            setSortMenuOpen(false);
            setSortSearchQuery("");
          }

          if (newFilter) {
            setActiveFilters((prevFilters) => ({
              ...prevFilters,
              [newFilter.label]: [
                ...(prevFilters[newFilter.label] || []),
                newFilter,
              ],
            }));
          }
        }
      }
    };

    const scrollItemIntoView = (index) => {
      const item = itemsRef1.current[index];
      if (item) {
        item.scrollIntoView({ behavior: "smooth", block: "nearest" });
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [
    localItemStatus,
    localItemBoards,
    activeFilters,
    setActiveFilters,
    setBoardsMenuOpen,
    setBoardsSearchQuery,
    boardsMenuOpen,
    sortMenuOpen,
    setSortMenuOpen,
  ]);

  const transformColorClass = (bgClass) => {
    return bgClass.replace("bg-", "");
  };

  // Badge Component
  const BadgeTags = ({ borderColor }) => (
    <span
      className={`flex h-[8px] w-[8px] shrink-0 items-center justify-center rounded-full text-[0.625rem] font-medium text-white border-2 border-solid border-${borderColor}`}
    />
  );

  const BadgeBoards = ({ borderColor }) => (
    <span
      className={`flex h-[8px] w-[8px] shrink-0 items-center justify-center rounded-[2px] text-[0.625rem] font-medium text-white bg-[${borderColor}]`}
    />
  );

  const BadgeStatus = ({ borderColor }) => (
    <span
      className={`flex h-[8px] w-[8px] shrink-0 items-center justify-center rounded-full text-[0.625rem] font-medium text-white bg-[${borderColor}]`}
    />
  );

  const BadgeAssign = ({ borderColor }) => (
    <span
      className={`flex h-[8px] w-[8px] shrink-0 items-center justify-center rounded-full text-[0.625rem] font-medium text-white ${borderColor}`}
    />
  );

  const BadgesInternal = ({ borderColor, profilePic }) => (
    <div className="w-5 h-5 rounded-full bg-gray-200 flex items-center justify-center text-[10px] overflow-hidden">
      {profilePic ? (
        <img
          src={
            profilePic
              ? `${process.env.REACT_APP_API_BASE_URL}/${profilePic}`
              : ""
          }
          alt="Profile"
          className="w-full h-full object-cover rounded-full"
        />
      ) : (
        <span className="text-[7px] font-medium text-gray-700">
          {borderColor ? borderColor.charAt(0) : ""}
        </span>
      )}
    </div>
  );

  const hasActiveFilters = Object.values(activeFilters).some(
    (filters) => filters.length > 0,
  );
  // const hasActiveFilters = useMemo(() => {
  //   return Object.values(activeFilters).some(filter =>
  //     Array.isArray(filter) ? filter.length > 0 : Boolean(filter)
  //   ) || activeFilters.search;
  // }, [activeFilters]);

  // Add sort options
  const sortOptions = [
    {
      id: uuidv4(),
      label: "Created first",
      value: "created_asc",
      icon: <SortAscendingIcon />, // Use a string identifier instead of JSX
      onClick: () => {
        toggleFilter("Sort", {
          id: uuidv4(),
          value: "Created first",
          icon: "sort-icon", // Store a string identifier instead of the JSX
        });
        setSortMenuOpen(false);
        clearPaginationFromState();
      },
    },
    {
      id: uuidv4(),
      label: "Created last",
      value: "created_desc",
      icon: <SortDecendingIcon />,
      onClick: () => {
        toggleFilter("Sort", {
          id: uuidv4(),
          value: "Created last",
          icon: "sort-icon",
        });
        setSortMenuOpen(false);
        clearPaginationFromState();
      },
    },
    {
      id: uuidv4(),
      label: "Updated first",
      value: "updated_asc",
      icon: <SortAscendingIcon />,
      onClick: () => {
        toggleFilter("Sort", {
          id: uuidv4(),
          value: "Updated first",
          icon: "sort-icon",
        });
        setSortMenuOpen(false);
        clearPaginationFromState();
      },
    },
    {
      id: uuidv4(),
      label: "Updated last",
      value: "updated_desc",
      icon: <SortDecendingIcon />,
      onClick: () => {
        toggleFilter("Sort", {
          id: uuidv4(),
          value: "Updated last",
          icon: "sort-icon",
        });
        setSortMenuOpen(false);
        clearPaginationFromState();
      },
    },
  ];

  const mainItems = [
    {
      id: uuidv4(),
      label: "Sort",
      icon: (
        <svg
          stroke="currentColor"
          fill="none"
          strokeWidth="2"
          viewBox="0 0 24 24"
          strokeLinecap="round"
          stroke-linejoin="round"
          focusable="false"
          aria-hidden="true"
          height="0.9em"
          width="0.9em"
          xmlns="XXXXXXXXXXXXXXXXXXXXXXXXXX"
        >
          <path d="M4 21v-7"></path>
          <path d="M4 10V3"></path>
          <path d="M12 21v-9"></path>
          <path d="M12 8V3"></path>
          <path d="M20 21v-5"></path>
          <path d="M20 12V3"></path>
          <path d="M1 14h6"></path>
          <path d="M9 8h6"></path>
          <path d="M17 16h6"></path>
        </svg>
      ),
      menuOpen: sortMenuOpen,
      setMenuOpen: setSortMenuOpen,
    },
    {
      id: uuidv4(),
      label: "Created at",
      icon: (
        <svg
          stroke="currentColor"
          fill="none"
          strokeWidth="2"
          viewBox="0 0 24 24"
          strokeLinecap="round"
          stroke-linejoin="round"
          focusable="false"
          aria-hidden="true"
          height="0.9em"
          width="0.9em"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
          <line x1="16" y1="2" x2="16" y2="6"></line>
          <line x1="8" y1="2" x2="8" y2="6"></line>
          <line x1="3" y1="10" x2="21" y2="10"></line>
        </svg>
      ),
      menuOpen: createdMenuOpen,
      setMenuOpen: setCreatedMenuOpen,
    },
    {
      id: uuidv4(),
      label: "Updated at",
      icon: (
        <svg
          stroke="currentColor"
          fill="none"
          strokeWidth="2"
          viewBox="0 0 24 24"
          strokeLinecap="round"
          stroke-linejoin="round"
          focusable="false"
          aria-hidden="true"
          height="0.9em"
          width="0.9em"
          xmlns="XXXXXXXXXXXXXXXXXXXXXXXXXX"
        >
          <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
          <line x1="16" y1="2" x2="16" y2="6"></line>
          <line x1="8" y1="2" x2="8" y2="6"></line>
          <line x1="3" y1="10" x2="21" y2="10"></line>
        </svg>
      ),
      menuOpen: updatedMenuOpen,
      setMenuOpen: setUpdatedMenuOpen,
    },
  ];

  // const getFilterIcon = (label) => {
  //   const matchingItems = mainItems.filter(item => item.label === label);
  //   return matchingItems.map(item => item.icon);
  // };

  // boards
  const boardsItems = localItemBoards?.map((item, index) => ({
    id: item.id,
    label: item.stage_name,
    icon: <BadgeBoards borderColor={item.stage_colour} />,
    onClick: () => {
      toggleFilter("Stages", {
        id: item.id,
        value: item.stage_name,
        icon: <BadgeBoards borderColor={item.stage_colour} />,
      });
      setBoardsMenuOpen(false);
      setBoardsSearchQuery("");
      setActiveIndex1(index);
    },
    className: activeIndex1 === index ? "bg-[#f1f1f2]" : "",
  }));

  const handleMainMenuClick = () => {
    setIsMainMenuOpen(!isMainMenuOpen);
    setBoardsMenuOpen(false);
    setUpdatedMenuOpen(false);
  };

  // create by
  const createdItems = [
    {
      id: uuidv4(),
      label: "2 days ago",
      onClick: () => {
        setActiveFilters([
          ...activeFilters,
          {
            id: uuidv4(),
            label: "Created at",
            icon: <span>🗓️</span>,
            value: "2 days ago",
          },
        ]);
        setCreatedMenuOpen(false);
        setCreatedSearchQuery("");
      },
    },
    {
      id: uuidv4(),
      label: "3 days ago",
      onClick: () => {
        setActiveFilters([
          ...activeFilters,
          {
            id: uuidv4(),
            label: "Created at",
            icon: <span>🗓️</span>,
            value: "3 days ago",
          },
        ]);
        setCreatedMenuOpen(false);
        setCreatedSearchQuery("");
      },
    },
    {
      id: uuidv4(),
      label: "4 days ago",
      onClick: () => {
        setActiveFilters([
          ...activeFilters,
          {
            id: uuidv4(),
            label: "Created at",
            icon: <span>🗓️</span>,
            value: "4 days ago",
          },
        ]);
        setCreatedMenuOpen(false);
        setCreatedSearchQuery("");
      },
    },
    {
      id: uuidv4(),
      label: "5 days ago",
      onClick: () => {
        setActiveFilters([
          ...activeFilters,
          {
            id: uuidv4(),
            label: "Created at",
            icon: <span>🗓️</span>,
            value: "5 days ago",
          },
        ]);
        setCreatedMenuOpen(false);
        setCreatedSearchQuery("");
      },
    },
  ];

  // const removeFilter = (filterId: string) => {
  //   setActiveFilters(prevFilters => prevFilters.filter(filter => filter.id !== filterId));
  // };

  // Filter sort options based on search query
  const filteredSortOptions = sortOptions.filter((item) =>
    item.label.toLowerCase().includes(sortSearchQuery.toLowerCase()),
  );

  const filteredBoardsItems = boardsItems.filter((item) =>
    item.label.toLowerCase().includes(boardsSearchQuery.toLowerCase()),
  );

  const filteredCreatedItems = createdItems.filter((item) =>
    item.label.toLowerCase().includes(createdSearchQuery.toLowerCase()),
  );

  const filteredMainItems = mainItems.filter((item) =>
    item.label.toLowerCase().includes(searchQuery.toLowerCase()),
  );

  const removeFilter = (category, id) => {
    if (category === "search") {
      clearAll();
      setActiveFilters((prevFilters) => ({
        ...prevFilters,
        search: "",
      }));
    } else {
      setActiveFilters((prevFilters) => ({
        ...prevFilters,
        [category]: (prevFilters[category] || []).filter(
          (filter) => filter.id !== id,
        ),
      }));
    }
  };

  useEffect(() => {
    if (selectedValuesRef.current) {
      setSectionHeight(selectedValuesRef.current.offsetHeight);
    } else {
      setSectionHeight(0);
    }
  }, [activeFilters]);

  const handleClearAll = () => {
    clearAll(); // This will clear the searchTerm in context
    setActiveFilters({
      Stages: [],
      "Created at": [],
      "Updated By": [],
      Sort: [],
      search: "",
      pagination: {
        pageIndex: 0,
        pageSize: 25,
        currentPage: 1,
      },
    });
    localStorage.removeItem("activeFiltersJobReports");
    // Re-initialize with default pagination
    localStorage.setItem(
      "activeFiltersJobReports",
      JSON.stringify({
        Stages: [],
        "Created at": [],
        "Updated By": [],
        Sort: [],
        search: "",
        pagination: {
          pageIndex: 0,
          pageSize: 25,
          currentPage: 1,
        },
      }),
    );
  };

  const FilterButton: React.FC<FilterButtonProps> = ({
    label,
    onClick,
    activeFilters,
  }) => {
    const totalActiveFilters = activeFilters
      ? Object.values(activeFilters).reduce(
          (acc, filters) => acc + filters.length,
          0,
        )
      : 0;

    const isActive = totalActiveFilters > 0;

    const buttonClassName = `
      ml-0 lg:ml-[0.5rem] 
      flex items-center gap-[0.4rem] md:gap-[0.5rem] lg:gap-[0.5rem] 
      rounded-md py-[6px] px-[0.5rem] 
      text-[12px] md:text-[0.8125rem] lg:text-[0.8125rem] 
      font-semibold
      transition-colors duration-200
      ${
        isActive
          ? "bg-blue-500 text-white hover:bg-blue-600"
          : "bg-white text-dark-black-100 hover:bg-light-gray-100"
      }
    `;

    return (
      <button
        type="button"
        className={`ml-0 lg:ml-[0rem] flex items-center gap-[0.4rem] md:gap-[0.5rem] lg:gap-[0.5rem] rounded-md py-[6px] px-[0.5rem] hover:bg-light-gray-100 text-[12px] md:text-[0.8125rem] lg:text-[0.8125rem] ${
          hasActiveFilters ? "text-red" : "text-dark-black-100"
        }`}
        onClick={onClick}
      >
        <svg
          stroke="currentColor"
          fill="none"
          strokeWidth="2"
          viewBox="0 0 24 24"
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden="true"
          focusable="false"
          height="1em"
          width="1em"
          className={hasActiveFilters ? "#text-[#111827] " : "text-[#0000007a]"}
          xmlns="http://www.w3.org/2000/svg"
        >
          <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"></polygon>
        </svg>
        <span
          className={
            hasActiveFilters
              ? "#text-[#111827] leading-[1.2] text-[12px] md:text-[0.8125rem] lg:text-[0.8125rem] font-semibold"
              : "text-[#0000007a]  leading-[1.2] text-[12px] md:text-[0.8125rem] lg:text-[0.8125rem] font-semibold"
          }
        >
          {label}
        </span>
      </button>
    );
  };

  const handleTagChange = (newValue) => {
    setSelectedTags(newValue);
  };

  const boardsMenuRef = useRef(null);
  const statusMenuRef = useRef(null);
  const subStatusMenuRef = useRef(null);
  const tagsMenuRef = useRef(null);
  const assignMenuRef = useRef(null);
  const priorityMenuRef = useRef(null);
  const sentimentMenuRef = useRef(null);
  const createdMenuRef = useRef(null);
  const updatedMenuRef = useRef(null);
  const mainMenuRef = useRef(null);
  const handleClickOutside = (event) => {
    if (
      boardsMenuRef.current &&
      !boardsMenuRef.current.contains(event.target)
    ) {
      setBoardsMenuOpen(false);
    }
    if (
      createdMenuRef.current &&
      !createdMenuRef.current.contains(event.target)
    ) {
      setCreatedMenuOpen(false);
    }
    if (
      updatedMenuRef.current &&
      !updatedMenuRef.current.contains(event.target)
    ) {
      setUpdatedMenuOpen(false);
    }
    if (mainMenuRef.current && !mainMenuRef.current.contains(event.target)) {
      setIsMainMenuOpen(false);
    }
    if (sortMenuRef.current && !sortMenuRef.current.contains(event.target)) {
      setSortMenuOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // created at
  const [value, setValue] = useState({
    startDate: null,
    endDate: null,
  });
  const [updateValue, setUpdateValue] = useState({
    startDate: null,
    endDate: null,
  });

  // const handleValueChange = (newValue) => {
  //   if (newValue.startDate && newValue.endDate) {
  //     const formattedStartDate = format(new Date(newValue.startDate), 'd MMMM yyyy');
  //     const formattedEndDate = format(new Date(newValue.endDate), 'd MMMM yyyy');
  //   }
  //   setValue(newValue);
  // }
  const handleValueChange = (newValue) => {
    if (newValue.startDate && newValue.endDate) {
      const formattedStartDate = format(
        new Date(newValue.startDate),
        "d MMMM yyyy",
      );
      const formattedEndDate = format(
        new Date(newValue.endDate),
        "d MMMM yyyy",
      );

      const dateFilter = {
        id: "date-range",
        label: "Date Range",
        value: `${formattedStartDate} - ${formattedEndDate}`,
        icon: null, // Add an icon if needed
      };

      setActiveFilters((prevFilters) => ({
        ...prevFilters,
        ["Created at"]: [dateFilter], // Replace existing date range filter
      }));
    }
    clearPaginationFromState();
    setValue(newValue);
    setCreatedMenuOpen(false);
  };

  const handleUpdatedValueChange = (newValue) => {
    if (newValue.startDate && newValue.endDate) {
      const formattedStartDate = format(
        new Date(newValue.startDate),
        "d MMMM yyyy",
      );
      const formattedEndDate = format(
        new Date(newValue.endDate),
        "d MMMM yyyy",
      );

      const dateFilter = {
        id: "date-range",
        label: "Date Range",
        value: `${formattedStartDate} - ${formattedEndDate}`,
        icon: null, // Add an icon if needed
      };

      setActiveFilters((prevFilters) => ({
        ...prevFilters,
        ["Updated at"]: [dateFilter], // Replace existing date range filter
      }));
    }
    clearPaginationFromState();
    setUpdateValue(newValue);
    setUpdatedMenuOpen(false);
  };
  const [openCategoryMenu, setOpenCategoryMenu] = useState(null);

  // New function to handle updating a specific filter
  const handleValueClick = (category, id) => {
    setOpenCategoryMenu(category);
    setEditingFilter({ category, id });
    setBoardsMenuOpen(category === "Stages");
    setCreatedMenuOpen(category === "Created at");
    setUpdatedMenuOpen(category === "Updated at");
    setSortMenuOpen(category === "Sort");
  };

  // const renderIcon = (icon) => {
  //   if (icon && icon.type && icon.props) {
  //     return React.createElement(icon.type, icon.props);
  //   }

  //   return null;
  // };

  const renderIcon = (icon) => {
    if (typeof icon === "string") {
      // Return the appropriate icon based on string identifiers
      if (icon === "sort-icon") {
        return (
          <svg
            stroke="currentColor"
            fill="none"
            strokeWidth="2"
            viewBox="0 0 24 24"
            strokeLinecap="round"
            strokeLinejoin="round"
            focusable="false"
            aria-hidden="true"
            height="0.9em"
            width="0.9em"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M4 21v-7"></path>
            <path d="M4 10V3"></path>
            <path d="M12 21v-9"></path>
            <path d="M12 8V3"></path>
            <path d="M20 21v-5"></path>
            <path d="M20 12V3"></path>
            <path d="M1 14h6"></path>
            <path d="M9 8h6"></path>
            <path d="M17 16h6"></path>
          </svg>
        );
      }
      // Add more icon types as needed
      return null;
    } else if (icon && icon.type && icon.props) {
      // Keep the original functionality for other icon types
      return React.createElement(icon.type, icon.props);
    }
    return null;
  };

  // New function to handle updating a specific filter
  // const handleFilterUpdate = (category, oldId, newId, newValue, newIcon) => {
  //   setActiveFilters((prevFilters) => ({
  //     ...prevFilters,
  //     [category]: prevFilters[category].map(filter =>
  //       filter.id === oldId ? { ...filter, id: newId, value: newValue, icon: { type: newIcon.type, props: newIcon.props } } : filter

  //     )
  //   }));
  //   setOpenCategoryMenu(null);
  //   setEditingFilter(null);
  //   setBoardsMenuOpen(false);
  //   setCreatedMenuOpen(false);
  //   setUpdatedMenuOpen(false);

  // };

  const handleFilterUpdate = (category, oldId, newId, newValue, newIcon) => {
    // setActiveFilters((prevFilters) => ({
    //   ...prevFilters,
    //   [category]: [{ id: newId, value: newValue, icon: { type: newIcon.type, props: newIcon.props } }] // Only keep the new filter
    // }));
    setActiveFilters((prevFilters) => ({
      ...prevFilters,
      [category]: [{ id: newId, value: newValue, icon: newIcon }], // Store string identifier or simple data
    }));
    setOpenCategoryMenu(null);
    setEditingFilter(null);
    setBoardsMenuOpen(false);
    setCreatedMenuOpen(false);
    setUpdatedMenuOpen(false);
    setSortMenuOpen(false);
  };

  // Set activeFilters to local storage

  useEffect(() => {
    localStorage.setItem(
      "activeFiltersJobReports",
      JSON.stringify(activeFilters),
    );
  }, [activeFilters]);

  const clearPaginationFromState = () => {
    window.dispatchEvent(new CustomEvent("paginationresetsetate"));
  };

  return (
    <>
      <div
        className={`fixed top-[53px] rounded-tl-none rounded-tr-lg rounded-bl-none rounded-br-none bg-white `}
        style={{
         width: verticleSidebar
                          ? `calc(100% - 241px${isChatOpen ? " - 520px" : ""})`
                          : `calc(100% - 68px${isChatOpen ? " - 520px" : ""})`,
          zIndex: 3,
          borderTop: "1px solid #e0e0e0a1",
          borderBottom: "1px solid #e0e0e0a1",
          left: verticleSidebar ? "234px" : "59px",
        }}
      >
        <div className="flex h-full lg:h-[45px] shrink-0 justify-between items-center gap-1 md:gap-2 lg:gap-4  py-2 px-2 md:py-4 lg:py-4 md:px-4 lg:px-4 flex-wrap lg:flex-nowrap">
          <div className="flex items-center rounded-md w-full">
            <div className="relative flex items-center text-left w-full">
              {/* <div className="flex items-center ml-[0px]">
                                <button
                                    className={`px-[6px] md:px-2 lg:px-2 text-[12px] md:text-[0.8125rem] lg:text-[0.8125rem] leading-[1.2] font-semibold py-[5px]
               border border-r-0 border-solid border-[rgba(0, 0, 0, 0.08)] rounded-tl-md rounded-bl-md ${activeStatus === 'Application' ? 'bg-[#6b7280] text-white  border-[#6b7280]' : 'bg-[#f9fafa] text-[#0000007a] hover:text-black-100'}`}
                                    onClick={handleStatusDraft}
                                >
                                    Application
                                </button>
                                <button
                                    className={`px-[6px] md:px-2 lg:px-2 text-[12px] md:text-[0.8125rem] lg:text-[0.8125rem] leading-[1.2] font-semibold py-[5px] 
                    border border-r-0 border-solid border-[rgba(0, 0, 0, 0.08)]  ${activeStatus === 'Pipeline' ? 'bg-[#6b7280] text-white border-[#6b7280]' : 'bg-[#f9fafa] text-[#0000007a] hover:text-black-100'}`}
                                    onClick={handleStatusPending}
                                >
                                    Pipeline
                                </button>
                                <button
                                    className={`px-[6px] md:px-2 lg:px-2 text-[12px] md:text-[0.8125rem] lg:text-[0.8125rem] leading-[1.2] font-semibold py-[5px] border
               border-solid border-[rgba(0, 0, 0, 0.08)] rounded-tr-md rounded-br-md ${activeStatus === 'Reports' ? 'bg-[#6b7280] text-white border-[#6b7280]' : 'bg-[#f9fafa] text-[#0000007a] hover:text-black-100'}`}
                                    onClick={handleStatusCompleted}
                                >
                                    Reports
                                </button>
                            </div> */}
              <FilterButton label="Filter" onClick={handleMainMenuClick} />
              {hasActiveFilters && (
                <div className="flex items-end md:items-center lg:items-center justify-between px-4 ">
                  <div
                    className={`${!hasActiveFilters ? "py-0" : "py-0 flex justify-start flex-wrap w-full gap-2"}`}
                    ref={selectedValuesRef}
                  >
                    {Object.entries(activeFilters).map(([category, filters]) =>
                      category === "search"
                        ? filters && (
                            <div
                              key="search"
                              className="flex justify-start flex-wrap shrink-0 items-center bg-white py-0 pr-0 md:py-0 lg:py-0 md:pr-0 lg:pr-0 lg:flex-nowrap filter-btn"
                            >
                              <span className="border border-[#e5e7eb] border-solid text-[#6b7280] text-[0.75rem] gap-[0.675rem] leading-4 pr-1 pl-[0.625rem] py-1 bg-white rounded-md items-center inline-flex">
                                <span className="capitalize">Search</span>
                                <span className="bg-[#e5e7eb] w-[1px] h-[1rem] mx-1"></span>
                                <span className="text-[#111827] font-medium capitalize cursor-pointer">
                                  {filters}
                                </span>
                                <button
                                  onClick={() =>
                                    removeFilter("search", "search")
                                  }
                                  className="text-[#6b7280] rounded justify-center items-center w-[1.25rem] h-[1.25rem] flex ml-[-.375rem] cursor-pointer"
                                >
                                  <svg
                                    viewBox="0 0 24 24"
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="16"
                                    height="16"
                                    fill="currentColor"
                                    aria-hidden="true"
                                  >
                                    <path d="M11.9997 10.5865L16.9495 5.63672L18.3637 7.05093L13.4139 12.0007L18.3637 16.9504L16.9495 18.3646L11.9997 13.4149L7.04996 18.3646L5.63574 16.9504L10.5855 12.0007L5.63574 7.05093L7.04996 5.63672L11.9997 10.5865Z"></path>
                                  </svg>
                                </button>
                              </span>
                            </div>
                          )
                        : Array.isArray(filters) && filters.length > 0
                          ? filters.map(({ id, value, icon, color }) => {
                              return (
                                <div
                                  key={id}
                                  className="flex justify-start flex-wrap shrink-0 items-center bg-white py-0 pr-0 md:py-0 lg:py-0 md:pr-0 lg:pr-0 lg:flex-nowrap filter-btn"
                                >
                                  <span className="border border-[#e5e7eb] border-solid text-[#6b7280] text-[0.75rem] gap-[0.675rem] leading-4 pr-1 pl-[0.625rem] py-1 bg-white rounded-md items-center inline-flex">
                                    <span className="text-[#1d2025] w-2 h-2 rounded-full bg-transparent border-2 border-solid border-[#7d7f83] block"></span>
                                    <span className="capitalize">
                                      {category}
                                    </span>
                                    <span className="bg-[#e5e7eb] w-[1px] h-[1rem] mx-1"></span>

                                    <span className="mr-[-6px]">
                                      {" "}
                                      {renderIcon(icon)}
                                    </span>

                                    {color && (
                                      <span
                                        className="flex h-[8px] w-[8px] shrink-0 items-center justify-center rounded-full text-[0.625rem] font-medium text-white"
                                        style={{ backgroundColor: color }}
                                      ></span>
                                    )}
                                    <span
                                      className="text-[#111827] font-medium capitalize cursor-pointer"
                                      onClick={() =>
                                        handleValueClick(category, id)
                                      }
                                    >
                                      {value}
                                    </span>
                                    <button
                                      onClick={() => removeFilter(category, id)}
                                      className="text-[#6b7280] rounded justify-center items-center w-[1.25rem] h-[1.25rem] flex ml-[-.375rem] cursor-pointer"
                                    >
                                      <svg
                                        viewBox="0 0 24 24"
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="16"
                                        height="16"
                                        fill="currentColor"
                                        aria-hidden="true"
                                      >
                                        <path d="M11.9997 10.5865L16.9495 5.63672L18.3637 7.05093L13.4139 12.0007L18.3637 16.9504L16.9495 18.3646L11.9997 13.4149L7.04996 18.3646L5.63574 16.9504L10.5855 12.0007L5.63574 7.05093L7.04996 5.63672L11.9997 10.5865Z"></path>
                                      </svg>
                                    </button>
                                  </span>
                                </div>
                              );
                            })
                          : null,
                    )}
                  </div>
                </div>
              )}
              {hasActiveFilters && (
                <button
                  className="inline-flex items-center py-1 ml-auto justify-center rounded-md font-semibold min-w-[5rem] text-[0.8125rem] px-3 hover:bg-light-gray-100"
                  onClick={handleClearAll}
                >
                  Clear All
                </button>
              )}
              {isMainMenuOpen && (
                <div
                  ref={mainMenuRef}
                  className="absolute top-[27px] right-0 left-[0px] z-10 mt-2 mq575:w-[160px] mq3000:w-[234px] origin-top-right rounded-md bg-white filter-dropdown border border-solid border-[#00000014]"
                  style={{
                    boxShadow:
                      "0 10px 15px -3px rgba(0, 0, 0, 0.1),0 4px 6px -2px rgba(0, 0, 0, 0.05)",
                  }}
                >
                  <div className="py-1">
                    <input
                      type="search"
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                      className="w-full outline-none border-t-0 border-l-0 border-r-0 border-b border-solid border-[#00000029] 
                      rounded-none text-sm h-[36px] pl-[10px] pr-[30px focus:outline-none focus:shadow-none focus:ring-0 focus:border-[#00000029] font-normal text-[#9f9f9fff]"
                      placeholder="Filter..."
                    />
                    <span
                      className="right-0 w-[2.25rem] h-[2.25rem] text-sm flex items-center justify-center absolute text-[#000000eb] opacity-100 bg-[#fff] top-[2px]"
                      style={{ zIndex: 2 }}
                    >
                      F
                    </span>

                    {filteredMainItems.map((item) => (
                      <button
                        key={item.id}
                        className="text-dark-black-100 flex items-center gap-[0.5rem] px-[0.75rem] py-[0.375rem] h-[32px] text-[13px] font-normal cursor-pointer w-full hover:bg-[#f1f1f2] focus:bg-[#f1f1f2] active:bg-[#e7e7e8]"
                        onClick={() => {
                          item.setMenuOpen(true);
                          setIsMainMenuOpen(false);
                        }}
                      >
                        {item.icon}
                        {item.label}
                      </button>
                    ))}
                  </div>
                </div>
              )}
              {boardsMenuOpen && (
                <div
                  ref={boardsMenuRef}
                  className="absolute top-[27px] right-0 z-10 mt-2 left-[0px] mq575:w-[160px] mq3000:w-[234px] origin-top-right rounded-md bg-white filter-dropdown border border-solid border-[#00000014]"
                  style={{
                    boxShadow:
                      "0 10px 15px -3px rgba(0, 0, 0, 0.1),0 4px 6px -2px rgba(0, 0, 0, 0.05)",
                  }}
                >
                  <div className="py-1">
                    <input
                      type="search"
                      value={boardsSearchQuery}
                      onChange={(e) => setBoardsSearchQuery(e.target.value)}
                      className="w-full outline-none border-t-0 border-l-0 border-r-0 border-b border-solid border-[#00000029] 
                      rounded-none text-sm h-[36px] pl-[10px] pr-[30px focus:outline-none focus:shadow-none focus:ring-0 focus:border-[#00000029] font-normal text-dark-black-100"
                      placeholder="Status"
                    />
                    <span
                      className="right-0 w-[2.25rem] h-[2.25rem] text-sm flex items-center justify-center absolute text-[#000000eb]  opacity-100 bg-[#fff] top-[2px]"
                      style={{ zIndex: 2 }}
                    >
                      F
                    </span>
                    <div className=" overflow-auto max-h-[200px]">
                      {filteredBoardsItems.map((item, index) => (
                        <button
                          key={item.id}
                          // ref={el => itemsRef1.current[index] = el}
                          ref={(el) => (itemsRef1.current[index] = el)}
                          className={`text-dark-black-100 flex items-center gap-[0.5rem] px-[0.75rem] py-[0.375rem] h-[32px] text-[13px] font-normal cursor-pointer w-full hover:bg-[#f1f1f2] focus:bg-[#f1f1f2] ${item.className}`}
                          // onClick={item.onClick}
                          onClick={() => {
                            if (
                              editingFilter &&
                              editingFilter.category === "Stages"
                            ) {
                              handleFilterUpdate(
                                "Stages",
                                editingFilter.id,
                                item.id,
                                item.label,
                                item.icon,
                              );
                              clearPaginationFromState();
                            } else {
                              item.onClick();
                              clearPaginationFromState();
                            }
                          }}
                        >
                          {item.icon}
                          <span className=" whitespace-nowrap w-[150px] overflow-hidden text-ellipsis text-start">
                            {" "}
                            {item.label}
                          </span>
                        </button>
                      ))}
                    </div>
                  </div>
                </div>
              )}

              {sortMenuOpen && (
                <div
                  ref={sortMenuRef}
                  className="absolute top-[27px] right-0 z-10 mt-2 left-[0px] mq575:w-[160px] mq3000:w-[234px] origin-top-right rounded-md bg-white filter-dropdown border border-solid border-[#00000014]"
                  style={{
                    boxShadow:
                      "0 10px 15px -3px rgba(0, 0, 0, 0.1),0 4px 6px -2px rgba(0, 0, 0, 0.05)",
                  }}
                >
                  <div className="py-1">
                    <input
                      type="search"
                      value={sortSearchQuery}
                      onChange={(e) => setSortSearchQuery(e.target.value)}
                      className="w-full outline-none border-t-0 border-l-0 border-r-0 border-b border-solid border-[#00000029] 
        rounded-none text-sm h-[36px] pl-[10px] pr-[30px focus:outline-none focus:shadow-none focus:ring-0 focus:border-[#00000029] font-normal text-dark-black-100"
                      placeholder="Sort by..."
                    />
                    <span
                      className="right-0 w-[2.25rem] h-[2.25rem] text-sm flex items-center justify-center absolute text-[#000000eb] opacity-100 bg-[#fff] top-[2px]"
                      style={{ zIndex: 2 }}
                    >
                      F
                    </span>
                    <div className="overflow-auto max-h-[200px]">
                      {filteredSortOptions.map((item) => (
                        <button
                          key={item.id}
                          className="text-dark-black-100 flex items-center gap-[0.5rem] px-[0.75rem] py-[0.375rem] h-[32px] text-[13px] font-normal cursor-pointer w-full hover:bg-[#f1f1f2] focus:bg-[#f1f1f2] active:bg-[#e7e7e8]"
                          onClick={item.onClick}
                        >
                          {/* Show the icon */}
                          {renderIcon(item.icon)}
                          {item.label}
                        </button>
                      ))}
                    </div>
                  </div>
                </div>
              )}

              {createdMenuOpen && (
                <div
                  ref={createdMenuRef}
                  className="absolute top-[27px] right-0 z-10 mt-2 left-[0px] mq575:w-[160px] mq3000:w-[234px] origin-top-right rounded-md bg-white filter-dropdown border
             border-solid border-[#00000014] date-picker"
                  style={{
                    boxShadow:
                      "0 10px 15px -3px rgba(0, 0, 0, 0.1),0 4px 6px -2px rgba(0, 0, 0, 0.05)",
                  }}
                >
                  <Datepicker
                    value={value}
                    onChange={handleValueChange}
                    showShortcuts={true}
                  />
                </div>
              )}
              {updatedMenuOpen && (
                <div
                  ref={updatedMenuRef}
                  className="absolute top-[27px] right-0 z-10 mt-2 left-[0px] mq575:w-[160px] mq3000:w-[234px] origin-top-right rounded-md bg-white filter-dropdown border
                 border-solid border-[#00000014] date-picker"
                  style={{
                    boxShadow:
                      "0 10px 15px -3px rgba(0, 0, 0, 0.1),0 4px 6px -2px rgba(0, 0, 0, 0.05)",
                  }}
                >
                  <Datepicker
                    value={updateValue}
                    onChange={handleUpdatedValueChange}
                    showShortcuts={true}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="">
        {!showKanbanRoute && !showReports && activeButton === "one" && (
          <Reports hasActiveFilters={hasActiveFilters} />
        )}
      </div>
    </>
  );
}
